<template>
  <footer class="footer has-cards">
    <!-- <div class="container container-lg">
      <div class="row">
        <div class="col-md-6 mb-5 mb-md-0">
          <div class="card card-lift--hover shadow border-0">
            <router-link to="/landing" title="Landing Page">
              <img v-lazy="'img/theme/landing.jpg'" class="card-img" />
            </router-link>
          </div>
        </div>
        <div class="col-md-6 mb-5 mb-lg-0">
          <div class="card card-lift--hover shadow border-0">
            <router-link to="/profile" title="Profile Page">
              <img v-lazy="'img/theme/profile.jpg'" class="card-img" />
            </router-link>
          </div>
        </div>
      </div>
    </div> -->
    <div class="container">
      <div class="row row-grid align-items-center my-md">
        <div class="col-lg-6">
          <h3 class="text-primary font-weight-light mb-2">
            Obrigado por me visitar!
          </h3>
          <h4 class="mb-0 font-weight-light">
            Para entrar em contato clique <router-link to="/contact">aqui</router-link>
          </h4>
        </div>
        <div class="col-lg-6 text-lg-center btn-wrapper">
          <a
            target="_blank"
            rel="noopener"
            href="https://www.facebook.com/leandrocantiero1"
            class="btn btn-neutral btn-icon-only btn-facebook btn-round btn-lg"
            data-toggle="tooltip"
            data-original-title="Like us"
          >
            <i class="fa fa-facebook-square"></i>
          </a>
          <a
            target="_blank"
            rel="noopener"
            href="https://www.instagram.com/leandrocampag40"
            class="btn btn-neutral btn-icon-only btn-instagram btn-lg btn-round"
            data-toggle="tooltip"
            data-original-title="Follow us"
          >
            <i class="fa fa-instagram"></i>
          </a>
          <a
            target="_blank"
            rel="noopener"
            href="https://github.com/makinado?tab=repositories"
            class="btn btn-neutral btn-icon-only btn-github btn-round btn-lg"
            data-toggle="tooltip"
            data-original-title="Star on Github"
          >
            <i class="fa fa-github"></i>
          </a>
          <a
            target="_blank"
            rel="noopener"
            href="https://www.linkedin.com/in/leandro-cantiero-288bb5179/"
            class="btn btn-neutral btn-icon-only btn-linkedin btn-round btn-lg"
            data-toggle="tooltip"
            data-original-title="Follow me Github"
          >
            <i class="fa fa-linkedin"></i>
          </a>
        </div>
      </div>
      <hr />
      <div class="row align-items-center justify-content-md-between">
        <div class="col-md-6">
          <div class="copyright">
            &copy; {{ year }}
            <router-link to="/" rel="noopener"
              >Leandro Cantiero</router-link
            >
          </div>
        </div>
        <div class="col-md-6">
          <ul class="nav nav-footer justify-content-end">
            <li class="nav-item">
              <router-link
                to="/"
                class="nav-link"
                rel="noopener"
                >Home</router-link
              >
            </li>
            <li class="nav-item">
              <router-link
                to="/profile"
                class="nav-link"
                rel="noopener"
                >Sobre</router-link
              >
            </li>
            <li class="nav-item">
              <router-link
                to="/contact"
                class="nav-link"
                rel="noopener"
                >Contato</router-link
              >
            </li>
            <li class="nav-item">
              <router-link
                to="/articles"
                class="nav-link"
                rel="noopener"
                >Artigos</router-link
              >
            </li>
            <li class="nav-item">
              <a
                href="https://github.com/creativetimofficial/argon-design-system/blob/master/LICENSE.md"
                class="nav-link"
                target="_blank"
                rel="noopener"
                >MIT License</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "app-footer",
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style>
</style>
